import { motion, AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";
import './EditModal.css'

export default function ModernModal({ isOpen, onClose, children }) {

  if (!isOpen) return null;

  return createPortal(
    <AnimatePresence>
      <motion.div
        className="modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose} // 👈 clique dehors ferme
      >
        <motion.div
          className="modal-content"
          initial={{ scale: 0.9, y: 20 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0.9, y: 20 }}
          transition={{ duration: 0.2 }}
          onClick={(e) => e.stopPropagation()} // 👈 empêche fermeture si clique dedans
        >
          <button className="modal-close" onClick={onClose}>
            ✕
          </button>

          {children}

        </motion.div> {/* ← fermeture modal-content */}

      </motion.div> {/* ← fermeture modal-overlay */}

    </AnimatePresence>,
    document.body
  );
}